<template>
    <div :class="alertShow" v-if="alertMessage != ''">
        <div
            :id="this.id"
            :class="
                'alert alert-' +
                alertType +
                ' alert-dismissible fade ' +
                alertShow
            "
            role="alert"
        >
            {{ alertMessage }}
            <button
                type="button"
                class="close"
                aria-label="Close"
                @click="hideAlertMessage()"
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
    },

    data() {
        return {
            alertMessage: '',
            alertType: 'info',
            alertShow: '',
        };
    },

    methods: {
        showAlertMessage(type, message) {
            this.alertType = type;
            this.alertMessage = message;
            this.alertShow = 'show';

            // Smooth scroll to the top
            // window.scrollTo(0, 0);
        },

        hideAlertMessage() {
            this.alertShow = '';
        },

        handleError(error) {
            if (error.response != undefined) {
                // Log error on the console for debug purpose
                console.error(error.message);
                console.error(error.response.status);
                console.error(error.response.data);
                console.error(error.response.headers);

                let errorData = error.response.data;

                // Handle error and show the user a message
                // Add any error code as need
                switch (error.response.status) {
                    case (404, 422):
                        let transArgs = {};
                        if (errorData.transArgs != undefined) {
                            transArgs = errorData.transArgs;
                        }

                        this.showAlertMessage(
                            errorData.level,
                            app.locale.trans(errorData.transKey, transArgs)
                        );
                        break;
                    case 500:
                        this.showAlertMessage(
                            'danger',
                            app.locale.trans('user.cart.error.try_again')
                        );
                        break;
                    default:
                        this.showAlertMessage('danger', error.message);
                        break;
                }
            } else {
                console.error(error);
            }
        },
    },
};
</script>
